import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { PHONE_MEDIA_QUERY } from '../../common/responsive';
import { hapticsImpactLight } from '../../common/haptic';
import { openSelect } from '../../redux/slices/select';

const LANG_OPTIONS = [
  { value: 'en', labelKey: 'common.english' },
  { value: 'es', labelKey: 'common.spanish' },
  { value: 'pt', labelKey: 'common.portuguese' },
];

const Trigger = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.background.light};
  border: none;
  padding: 0;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.text.title};
  &:hover {
    opacity: 0.9;
  }
  @media ${PHONE_MEDIA_QUERY} {
    width: 38px;
    height: 38px;
    font-size: 12px;
  }
`;

const LanguageSelector = () => {
  const { i18n, t } = useTranslation();
  const dispatch = useDispatch();

  const lang = i18n.language?.split('-')[0] || 'en';
  const value = ['es', 'pt'].includes(lang) ? lang : 'en';

  const handleTriggerClick = () => {
    hapticsImpactLight();
    dispatch(
      openSelect({
        options: LANG_OPTIONS.map((opt) => ({
          value: opt.value,
          label: t(opt.labelKey),
        })),
        selectedOption: value,
        placeHolder: t('common.language'),
        onChange: (selectedValue) => {
          i18n.changeLanguage(selectedValue);
        },
      }),
    );
  };

  return (
    <Trigger
      type="button"
      onClick={handleTriggerClick}
      aria-label={t('common.language')}
    >
      {value.toUpperCase()}
    </Trigger>
  );
};

export default LanguageSelector;
